import { Base } from './GenericFormTypes';

export interface StatusOffer extends Base {}
export interface ApplicationStage extends Base {}
export interface Education extends Base {}
export interface LanguageLevel extends Base {}
export interface Language extends Base {}
export interface Certification extends Base {}
export interface Requirement extends Base {}
export interface Competence extends Base {}
export interface Benefit extends Base {}
export interface Law extends Base {}
export interface ContractType extends Base {}
export interface Period extends Base {}
interface DriverLicense extends Base {}
export interface School extends Base {
  id: number;
  name: string;
}
export interface SpecialtyArea extends Base {}
export interface Career extends Base {
  id: number;
  name: string;
  schoolId: number;
}
export interface Campus extends Base {
  id: number;
  name: string;
  email: string;
}
export interface WorkingDay extends Base {}
export interface Modality extends Base {}
export interface Subject extends Base {
  id: number;
  name: string;
  careerId: number;
}

export interface OfferLanguageLevel {
  language: Language;
  languageLevel: LanguageLevel;
}

export interface LicenseRequirements extends Base {
  driverLicense: DriverLicense;
}

interface Schedule extends Base {}

export enum OfferType {
  Private = 'private',
  Public = 'public',
}

export interface OfferDetail {
  id: number;
  name: string;
  vacant?: string;
  type?: OfferType;
  contract_period?: string;
  inclusionLaw: string;
  intrusionLaw?: string;
  salary?: string;
  description: string;
  levelResponsibility?: string;
  job_function?: string;
  dateInit?: string;
  updatedAt?: string;
  school: School;
  specialtyArea: SpecialtyArea;
  career?: Career;
  campus: Campus;
  workingDay: WorkingDay;
  modality: Modality;
  subject: Subject;
  statusOffer: StatusOffer;
  curriculum?: string;
  knowledge: string;
  applicationStages: ApplicationStage[];
  educations: Education[];
  offerLanguageLevels: OfferLanguageLevel[];
  certifications: Certification[];
  licenseTypes: any[];
  requirements: Requirement[];
  licenseRequirements: LicenseRequirements[];
  competencies: Competence[];
  benefits: Benefit[];
  draftFlowId: number;
}

export interface OfferCreationOptions {
  benefits: Benefit[];
  laws: Law[];
  campus: Campus[];
  contractTypes: ContractType[];
  modalities: Modality[];
  schedule: Schedule[];
  workingDays: WorkingDay[];
  specialtyAreas: SpecialtyArea[];
  subjects: Subject[];
  periods: Period[];
  schools: School[];
}

export interface PosibleOfferStateList {
  icon: 'eye' | 'error' | 'success' | 'warning' | 'waiting';
  id: number;
  name: string;
}

export interface UpdateOfferStateType {
  statusId: number;
}

export enum OfferStatus {
  // available = vigente
  Available = 1,
  InProgress = 3,
  Closed = 4,
  Finished = 5,
}
